import React from 'react';
import uniqueId from 'lodash/uniqueId';
import type { TSuiteBuffer, TSuiteBufferItem } from './types';


export default function createTestingSuiteBuffer(): TSuiteBuffer {
  const itemsPerActionPublicId: Record<string, TSuiteBufferItem> = {};
  return {
    append: entry => {
      const arr = Array.isArray(entry) ? entry : [entry];
      arr.forEach(entryToAppend => {
        const {
          actionPublicId,
          line,
          id = uniqueId(),
          isIneligible = false,
        } = entryToAppend;

        if (!Object.hasOwn(itemsPerActionPublicId, actionPublicId)) {
          itemsPerActionPublicId[actionPublicId] = {
            changeItems: [],
            containsIneligible: false,
          };
        }

        const itemForActionPublicId = itemsPerActionPublicId[actionPublicId];
        // only toggle this once when an ineligible change is first evaluated
        if (!itemForActionPublicId.containsIneligible && isIneligible) {
          itemForActionPublicId.containsIneligible = true;
        }
        itemForActionPublicId.changeItems.push({
          Component: line,
          id,
        });
      });
    },

    package: () => {
      const render = () => (
        <div style={{
          height: '100%',
          width: '100%',
          marginTop: 'calc(-1 * var(--cl-space-2))',
          paddingLeft: 'var(--cl-space-4)',
        }}
        >
          {(
            Object
              .values(itemsPerActionPublicId)
              .flatMap(linesForAction => linesForAction.changeItems
                .map(({ Component, id }) => <Component key={id} />))
          )}
        </div>
      );

      return {
        render,
        data: itemsPerActionPublicId,
      };
    },
  };
}
